import hy from './languages/hy.json';

const translations = {
    hy: hy
};
export default translations;
